import i18n from '@/i18n'

export function getDateLocale(lang = i18n.language): string {
  return lang.startsWith('zh') ? 'zh-CN' : 'en-US'
}

export function getNumberLocale(lang = i18n.language): string {
  return getDateLocale(lang)
}
